import { useEffect } from "react";
/** Closes when pointer down occurs outside both boundary elements. */
export function useClickOutside(enabled, onOutside, boundaryA, boundaryB) {
    useEffect(() => {
        if (!enabled)
            return;
        function handlePointerDown(event) {
            const target = event.target;
            const isInside = (boundaryA != null && boundaryA.contains(target)) ||
                (boundaryB != null && boundaryB.contains(target));
            if (!isInside) {
                onOutside();
            }
        }
        document.addEventListener("mousedown", handlePointerDown);
        return () => document.removeEventListener("mousedown", handlePointerDown);
    }, [enabled, onOutside, boundaryA, boundaryB]);
}
